/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import "./App.css";
import { FaEdit } from 'react-icons/fa'; // For edit icon

function App() {
  const [invoice, setInvoice] = useState(() => {
    const savedInvoice = localStorage.getItem("invoice");
    if (savedInvoice) {
      try {
        return JSON.parse(savedInvoice);
      } catch (e) {
        console.error("Failed to parse saved invoice data", e);
      }
    }
    // Return a fully initialized invoice structure if no saved data
    return {
      invoiceNo: "SHB/456/20",
      vehicleNo: "",
      date: "20-Dec-20",
      poNo: "",
      hsnSac: "",
      dcNo: "",
      poDate: "",
      dcDate: "",
      invoicetitle:"Invoice",
      seller: {
        name: "",
        address: "",
        gstin: "",
        state: "",
        code: "",
      },
      buyer: {
        name: "",
        address: "",
        gstin: "",
        state: "",
        code: "",
      },
      company: {
        name: "",
        address: "1234 Business St, City, Country",
        mobile: "11230 11230",
        proprietor: "",
      },
      items: [
        {
          sr_no: 1,
          dc_no: "",
          gsp_no: "",
          description: "",
          quantity: 1,
          rate: 0,
        },
      ],
      gstRate: 9, // Default CGST and SGST (each)
      bankDetails: {
        bankName: "",
        accountNumber: "",
        ifscCode: "",
        branch: "",
      },
    };
  });

  useEffect(() => {
    // Save to localStorage whenever invoice changes
    localStorage.setItem("invoice", JSON.stringify(invoice));
  }, [invoice]);

  const handleInputChange = (field, value, section) => {
    if (section) {
      setInvoice((prev) => ({
        ...prev,
        [section]: { ...prev[section], [field]: value },
      }));
    } else {
      setInvoice((prev) => ({ ...prev, [field]: value }));
    }
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...invoice.items];
    updatedItems[index][field] = value;
    setInvoice((prev) => ({
      ...prev,
      items: updatedItems,
    }));
  };

  const handleAddItem = () => {
    const newSrNo = invoice.items.length
      ? invoice.items[invoice.items.length - 1].sr_no + 1
      : 1; // Increment based on the last item's sr_no or start with 1

    setInvoice((prev) => ({
      ...prev,
      items: [
        ...prev.items,
        { sr_no: newSrNo, dc_no: "", gsp_no: "", description: "", quantity: 1, rate: 0 },
      ],
    }));
  };

  const handleRemoveItem = (index) => {
    // Don't allow removing items if fewer than 1 item remains
    if (invoice.items.length > 1) {
      const updatedItems = invoice.items.filter((_, i) => i !== index);
      // Recalculate serial numbers after removing an item
      const updatedItemsWithSrNo = updatedItems.map((item, index) => ({
        ...item,
        sr_no: index + 1, // Serial numbers start from 1
      }));

      setInvoice((prev) => ({
        ...prev,
        items: updatedItemsWithSrNo,
      }));
    }
  };

  const calculateTotals = () => {
    const subTotal = invoice.items.reduce(
      (total, item) => total + item.quantity * item.rate,
      0
    );
    const gstAmount = (subTotal * invoice.gstRate) / 100;
    return {
      subTotal,
      cgst: gstAmount,
      sgst: gstAmount,
      total: subTotal + 2 * gstAmount, // CGST + SGST
    };
  };
 // New state to track if the title is being edited
 const [isEditingTitle, setIsEditingTitle] = useState(false);
 const [tempTitle, setTempTitle] = useState(invoice.invoicetitle);
 const handleEditTitle = () => {
  setIsEditingTitle(true);
};

const handleTitleChange = (e) => {
  setTempTitle(e.target.value);
};

const handleSaveTitle = () => {
  handleInputChange("invoicetitle", tempTitle);
  setIsEditingTitle(false);
};

const handleCancelTitleEdit = () => {
  setTempTitle(invoice.invoicetitle); // Reset to original value
  setIsEditingTitle(false);
};
  const totals = calculateTotals();
  const handlePrint = () => {
    const printWindow = window.open("", "_blank");

    // Get totals calculated using your existing logic
    const { subTotal, cgst, sgst, total } = totals;

    printWindow.document.write(`
<html>

<head>
  <title>Invoice</title>

  <link href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.2/css/bootstrap.min.css" rel="stylesheet">

  <style>
   @media print {
  body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    font-size: 10pt;
  }

  .invoice-container {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    padding: 5mm;
    box-sizing: border-box;
    font-size: 10pt;
    line-height: 1.3;
    position: relative;
  }

    border: 2px solid #000;
      height: calc(100% - 20px);
      overflow: hidden;

  @page {
    size: auto;
    margin: 0;
  }
}

.company-name {
  font-size: 18pt;
  font-weight: bold;
  text-align: right;
  margin-bottom: 5mm;
}

.company-address {
  text-align: center;
  font-size: 10pt;
  margin-bottom: 5mm;
}

.seller-buyer-section {
  width: 40%;
}

.invoice-section {
  width: 40%;
  margin-bottom: 5mm;
  font-size: 10pt;
}

.items-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 9pt;
}

.items-table th,
.items-table td {
  border: 1pt solid #000;
  padding: 2mm;
  text-align: center;
}

.items-table th {
  background-color: #f0f0f0;
  font-weight: bold;
}

.items-table td {
  padding: 5px;
  text-align: left;
}

.totals {
  text-align: left;
  margin-top: 5mm;
  font-size: 10pt;
  width: 48%;
  align-self: right;
}

.bank-details-total-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 5mm;
}

.bank-details-section {
  width: 48%;
  font-size: 10pt;
  padding-top: 3mm;
}

.bank-details-section table {
  width: 100%;
  font-size: 10pt;
}

.bank-details-section td {
  padding: 0.5mm;
}

.bank-details-section td:first-child {
  padding-left: 2mm;
}

.bank-details-section td:last-child {
  padding-right: 2mm;
}

.signature-section {
  text-align: left;
  font-size: 10pt;
  position: absolute;
  right: 10mm;
}

.signature-line {
  border-top: 1px solid black;
  width: 200px;
  margin-top: 60px;
  display: flex;
  align-items: center;
}

.signature-line-text {
  margin-left: 10px;
  font-style: italic;
}

.terms-box {
  width: 100%;
  padding: 10px;
  border: 1px solid #000;
  font-size: 10pt;
  margin-bottom: 15mm;
}

.terms-box h4 {
  margin-bottom: 5mm;
}

.bottom-section {
  width: 100%;
}

.bank-header {
  border: 2px solid #333;
}

.bank-header .row {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
}

.gst-section {
  border: 1px solid #000;
  padding: 5px;
}

.company-info {
  border-right: 1px solid #000;
}

.company-info,
.invoice-info {
  flex: 1;
  padding: 10px;
}

.company-info h2,
.invoice-info h2 {
  margin-bottom: 3mm;
}

.invoice-header {
  border: 2px solid #333;
}

.invoice-header .row {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
}

@media screen {
  .invoice-container {
    background-color: white;
    padding: 30px;
    margin: 20px auto;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    max-width: 210mm;
  }

  body {
    background-color: #f8f9fa;
  }
}
@media screen {
  .invoice-container {
    background-color: white;
    padding: 30px;
    margin: 20px auto;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    max-width: 210mm;
  }

  body {
    background-color: #f8f9fa;
  }

  input {
    border: 1px solid #ddd;
    padding: 5px;
    margin: 2px;
    font-size: 10pt;
  }

  input:focus {
    outline: none;
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

  button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 5px 10px;
    border-radius: 4px;
    cursor: pointer;
    margin: 2px;
  }

  button:hover {
    background-color: #0056b3;
  }

  .company-name input {
    font-size: 18pt;
    text-align: right;
    width: 100%;
    border: none;
    font-weight: bold;
  }

  .seller-buyer-section input {
    width: 100%;
    margin-bottom: 5px;
  }

  .invoice-section input {
    width: 100%;
    margin-bottom: 5px;
  }

  .items-table input {
    width: 100%;
    border: none;
    background: transparent;
  }

  .items-table input:focus {
    background: white;
  }

  .bank-details-section input {
    width: 100%;
    margin-bottom: 5px;
  }

  .totals input {
    border: none;
    background: transparent;
    font-weight: bold;
  }

  .gst-section input {
    width: 150px;
    margin-left: 10px;
  }

  .signature-section input {
    border: none;
    text-align: center;
    width: 200px;
    margin-bottom: 5px;
  }

  .items-table button {
    padding: 2px 5px;
    font-size: 8pt;
  }

  .no-print {
    display: block;
  }

  .bank-header input {
    width: 100%;
    margin-bottom: 5px;
  }
}
  </style>
</head>

<body>
  <div class="container invoice-container">
 
    <!-- Company Header -->
    <div class="company-header">
      <h1>${invoice.company.name}</h1>
    </div>
 <div class="bill-container">
    <!-- Invoice Header -->
    <div class="invoice-header container">
      <div class="row">
        <div class="col-md-6 company-info">
          <h2 class="h5 fw-bold mt-2">${invoice.seller.name || '-'}</h2>
          <p class="mb-1">${invoice.seller.address || '-'}</p>
          <h2 class="h5 fw-bold mt-5">${invoice.buyer.name || '-'} - ${invoice.buyer.code || '-'}</h2>
          <p class="mb-1">GSTN No.: ${invoice.buyer.gstin || '-'}</p>
          <p class="mb-0">Place of Supply: ${invoice.buyer.address || '-'}</p>
        </div>
        <div class="col-md-6 invoice-info">
          <h3 class="h5 fw-bold mb-3">${invoice.taxTitle || '-'} </h3>
          <p class=" mb-1">${invoice.invoicetitle} No.: ${invoice.invoiceNo || '-'}</p>
           <p class=" mb-1">Vehicle No.: ${invoice.vehicleNo || '-'}</p>
          <p class=" mb-1">Date: ${invoice.date || '-'}</p>
          <p class=" mb-1">PO No.: ${invoice.poNo || '-'}</p>
          <p class=" mb-1">PO Date: ${invoice.poDate || '-'}</p>
          <p class=" mb-1">HSN/SAC: ${invoice.hsnSac || '-'}</p>
          <p class=" mb-1">DC No.: ${invoice.dcNo || '-'}</p>
          <p class=" mb-0">DC Date:${invoice.dcDate || '-'}</p>
        </div>
      </div>
    </div>

    <!-- GST Section -->
    <div class="gst-section">
      <p><strong>GST Rate:</strong> ${invoice.gstRate}%</p>
    </div>

  <table class="items-table">
  <thead>
    <tr>
     <th>Sr no.</th>
      <th>Description</th>
      <th>DC No/ PO No</th>
      <th>DRG No</th>
      <th>Quantity</th>
      <th>Rate</th>
      <th>Amount</th>
    </tr>
  </thead>
  <tbody>
     ${invoice.items.map((item, index) => `
          <tr>
            <td style="border: 1px solid #000; padding: 5px; text-align: center;">${item.sr_no || ""}</td>
            <td style="border: 1px solid #000; padding: 5px; text-align: left;">${item.description || ""}</td>
            <td style="border: 1px solid #000; padding: 5px; text-align: center;">${item.dc_no || ""}</td>
            <td style="border: 1px solid #000; padding: 5px; text-align: center;">${item.gsp_no || ""}</td>
            <td style="border: 1px solid #000; padding: 5px; text-align: center;">${item.quantity || ""}</td>
            <td style="border: 1px solid #000; padding: 5px; text-align: center;">${item.rate || ""}</td>
            <td style="border: 1px solid #000; padding: 5px; text-align: right;">₹${(item.quantity * item.rate).toFixed(2) || ""}</td>
          </tr>
        `).join('')}
  </tbody>
</table>
 <!-- GST Section -->
    <div class="gst-section">
      <p><strong>GST No.:</strong> ${invoice.seller.gstin || '-'}</p>
    </div>
<div class="bottom-section">
<!-- Totals and Bank Details -->
<div class="bank-header container bank-total-section">
    <div class="row">
        <!-- Bank Details Section -->
        <div class="col-md-5 company-info">
            <h2 class="h5 fw-bold mt-2">Bank Details</h2>
            <table>
                <tr>
                    <td>Bank Name: </td>
                    <td>${invoice.bankDetails.bankName}</td>
                </tr>
                <tr>
                    <td>Account Number: </td>
                    <td>${invoice.bankDetails.accountNumber}</td>
                </tr>
                <tr>
                    <td>IFSC Code: </td>
                    <td>${invoice.bankDetails.ifscCode}</td>
                </tr>
                <tr>
                    <td>Branch: </td>
                    <td>${invoice.bankDetails.branch}</td>
                </tr>
            </table>
        </div>

        <!-- Totals Section -->
        <div class="col-md-5 invoice-info">
              <h2 class="h5 fw-bold mt-2">Total Amount</h2>
            <p><strong>Subtotal:</strong> ₹${subTotal.toFixed(2)}</p>
            <p><strong>GST (CGST & SGST):</strong> ₹${(cgst + sgst).toFixed(2)}</p>
            <p><strong>Total Amount:</strong> ₹${total.toFixed(2)}</p>
        </div>
    </div>
</div>

    </div>
     <!-- Signature Section -->
    <div class="signature-section">
      <div class="signature-line">
        <p>${invoice.company.proprietor}
          <p />
          <span class="signature-line-text">Authorized Signature</span>
      </div>
    </div>
    </div>
  </div>
  
</body>

</html>
`);


    printWindow.document.close(); // Ensure the document is fully written
    printWindow.focus(); // Focus on the new window
    printWindow.print(); // Trigger the print dialog
    // Do not close the window automatically
  };

  return (
    <div className="invoice-container" id="printable-invoice">
      <h1 className="company-name">
        {" "}
        <input type="text" value={invoice.company.name} onChange={(e) => handleInputChange("name", e.target.value, "company")} placeholder="Your Company Name"
        />
      </h1>
      {/* <p className="company-address"> <input type="text" value={invoice.company.address} onChange={(e)=> handleInputChange("address", e.target.value, "company")}
        /></p>
        <p className="company-address"> <input type="text" value={invoice.company.mobile} onChange={(e)=> handleInputChange("mobile", e.target.value, "company")}
          /></p> */}

      <div className="seller-buyer-section">
        <div className="row">
          {/* Seller Section */}
          <div className="col-md-7">
            <input type="text" placeholder="Name" value={invoice.seller.name} onChange={(e) =>
              handleInputChange("name", e.target.value, "seller")
            }
            />
            <input type="text" placeholder="Address" value={invoice.seller.address} onChange={(e) =>
              handleInputChange("address", e.target.value, "seller")
            }
            />
            <div className="row mt-5">
              {" "}
              <div className="col-md-8">
                <input type="text" placeholder="Name" value={invoice.buyer.name} onChange={(e) =>
                  handleInputChange("name", e.target.value, "buyer")
                }
                />
              </div>
              <div className="col-md-4">
                <input type="text" placeholder="State Code" value={invoice.buyer.code} onChange={(e) =>
                  handleInputChange("code", e.target.value, "buyer")
                }
                />
              </div>
            </div>
            <input type="text" placeholder="GSTIN" value={invoice.buyer.gstin} onChange={(e) =>
              handleInputChange("gstin", e.target.value, "buyer")
            }
            />
            <input type="text" placeholder="Place of supply" value={invoice.buyer.address} onChange={(e) =>
              handleInputChange("address", e.target.value, "buyer")
            }
            />
          </div>

          {/* Invoice Section (next to Seller) */}
          <div className="col-md-5">
            <div className="invoice-section">

              <label>Tax Title: </label>
              <input type="text" value={invoice.taxTitle} onChange={(e) => handleInputChange("taxTitle", e.target.value)}
              />
              {isEditingTitle ? (
                <>
                  <input
                    type="text"
                    value={tempTitle}
                    onChange={handleTitleChange}
                  />
                  <button type="submit" onClick={handleSaveTitle}>Save</button>
                  <button type="reset" onClick={handleCancelTitleEdit}>Cancel</button>
                </>
              ) : (
                <>
                 <label>{invoice.invoicetitle} No: </label>&nbsp;
                  <FaEdit onClick={handleEditTitle} style={{ cursor: "pointer"}} />
                </>
              )}
              <input type="text" value={invoice.invoiceNo} onChange={(e) => handleInputChange("invoiceNo", e.target.value)}
              />
              <label>Vehicle No: </label>
              <input type="text" value={invoice.vehicleNo} onChange={(e) => handleInputChange("vehicleNo", e.target.value)}
              />
              <label>Date: </label>
              <input type="date" value={invoice.date} onChange={(e) => handleInputChange("date", e.target.value)}
              />
            </div>

            {/* PO No and DC No Section */}
            <div className="row">
              <div className="col-md-5">
                <label>PO No: </label>
                <input type="text" value={invoice.poNo} onChange={(e) => handleInputChange("poNo", e.target.value)}
                />

                <label>PO Date: </label>
                <input type="date" value={invoice.poDate} onChange={(e) => handleInputChange("poDate", e.target.value)}
                />
                <label>
                  HSN/SAC:
                  <input type="text" value={invoice.hsnSac} onChange={(e) =>
                    handleInputChange("hsnSac", e.target.value)
                  }
                  />
                </label>
              </div>

              <div className="col-md-5">
                <label>DC No: </label>
                <input type="text" value={invoice.dcNo} onChange={(e) => handleInputChange("dcNo", e.target.value)}
                />
                <label>DC Date: </label>
                <input type="date" value={invoice.dcDate} onChange={(e) => handleInputChange("dcDate", e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Buyer Section */}
        {/* <div className="row">
      <div className="col-md-5">
        <h3>Buyer (To):</h3>
        <input type="text" placeholder="Name" value={invoice.buyer.name} onChange={(e)=> handleInputChange("name", e.target.value, "buyer")}
        />
        <input type="text" placeholder="Address" value={invoice.buyer.address} onChange={(e)=> handleInputChange("address", e.target.value, "buyer")}
        />
        <input type="text" placeholder="GSTIN" value={invoice.buyer.gstin} onChange={(e)=> handleInputChange("gstin", e.target.value, "buyer")}
        />
        <input type="text" placeholder="State" value={invoice.buyer.state} onChange={(e)=> handleInputChange("state", e.target.value, "buyer")}
        />
        <input type="text" placeholder="State Code" value={invoice.buyer.code} onChange={(e)=> handleInputChange("code", e.target.value, "buyer")}
        />
      </div>
    </div> */}
      </div>

      <div className="gst-section">
        <label>
          GST Rate (% for CGST & SGST):
          <input type="number" value={invoice.gstRate} onChange={(e) =>
            handleInputChange("gstRate", parseFloat(e.target.value))
          }
            min="0"
            step="0.01"
          />
        </label>
      </div>

      <table className="items-table">
        <thead>
          <tr>
            <th>Sr no.</th>
            <th>Description</th>
            <th>DC No/ PO No</th>
            <th>DRG No</th>
            <th>Quantity</th>
            <th>Rate</th>
            <th>Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {invoice.items.map((item, index) => (
            <tr key={index}>
              <td>  <label>{item.sr_no}</label></td>

              <td>
                <input type="text" value={item.description} onChange={(e) =>
                  handleItemChange(index, "description", e.target.value)
                }
                />
              </td>
              <td>
                <input type="text" value={item.dc_no} onChange={(e) =>
                  handleItemChange(index, "dc_no", e.target.value)
                }
                />
              </td>
              <td>
                <input type="text" value={item.gsp_no} onChange={(e) =>
                  handleItemChange(index, "gsp_no", e.target.value)
                }
                />
              </td>
              <td>
                <input type="number" value={item.quantity} onChange={(e) =>
                  handleItemChange(index, "quantity", e.target.value)
                }
                />
              </td>
              <td>
                <input type="number" value={item.rate} onChange={(e) =>
                  handleItemChange(index, "rate", e.target.value)
                }
                />
              </td>

              <td>₹{(item.quantity * item.rate).toFixed(2)}</td>
              <td>
                <button onClick={() => handleRemoveItem(index)}>Remove</button>
              </td>
            </tr>
          ))}
          <tr>
            <td colSpan="8">
              <button onClick={handleAddItem}>Add Item</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div className="gst-section">
        <label>
          GSTIN:
          <input type="text" placeholder="GSTIN" value={invoice.seller.gstin} onChange={(e)=> handleInputChange("gstin", e.target.value, "seller")}
          />
        </label>
      </div>
      <div className="totals-and-bank">
        <div className="signature-section">
          <div className="bank-details-section">
            <h3>Bank Details:</h3>
            <table>
              <tbody>
                <tr>
                  <td>Bank Name</td>
                  <td>
                    <input type="text" value={invoice.bankDetails.bankName} onChange={(e) =>
                      handleInputChange(
                        "bankName",
                        e.target.value,
                        "bankDetails"
                      )
                    }
                    />
                  </td>
                </tr>
                <tr>
                  <td>Account Number</td>
                  <td>
                    <input type="text" value={invoice.bankDetails.accountNumber} onChange={(e) =>
                      handleInputChange(
                        "accountNumber",
                        e.target.value,
                        "bankDetails"
                      )
                    }
                    />
                  </td>
                </tr>
                <tr>
                  <td>IFSC Code</td>
                  <td>
                    <input type="text" value={invoice.bankDetails.ifscCode} onChange={(e) =>
                      handleInputChange(
                        "ifscCode",
                        e.target.value,
                        "bankDetails"
                      )
                    }
                    />
                  </td>
                </tr>
                <tr>
                  <td>Branch</td>
                  <td>
                    <input type="text" value={invoice.bankDetails.branch} onChange={(e) =>
                      handleInputChange(
                        "branch",
                        e.target.value,
                        "bankDetails"
                      )
                    }
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="totals">
          <p>
            <b>Sub Total:</b> ₹{totals.subTotal.toFixed(2)}
          </p>
          <p>
            <b>CGST @ {invoice.gstRate}%:</b> ₹{totals.cgst.toFixed(2)}
          </p>
          <p>
            <b>SGST @ {invoice.gstRate}%:</b> ₹{totals.sgst.toFixed(2)}
          </p>
          <h3>
            <b>Total:</b> ₹{totals.total.toFixed(2)}
          </h3>

          <p>
            <b>
              For,
              <input style={{ width: "200px", border: "none" }} type="text" placeholder="Enter Proprietor's Name" value={invoice.company.proprietor || ""} onChange={(e) =>
                handleInputChange("proprietor", e.target.value, "company")
              }
              />
            </b>
          </p>
          <div className="signature-line">
            <span className="signature-line-text">Signature</span>
          </div>
          <button onClick={handlePrint}>Print Invoice</button>
        </div>
      </div>
      <div className="w-full py-4 mt-8 bg-gray-100 border-t border-gray-200 text-center">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-600 text-sm mb-2 md:mb-0">
            Created by <span className="font-semibold">βtacode.</span>
          </div>
          <div className="text-gray-600 text-sm">
            Developed by <span className="font-semibold">Raaj</span>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}

export default App;